export const countryProfile = {
  countrySummary: {
    text: "معلومات موجزة عن البلد",
    keyContacts: "جهات الاتصال الرئيسية",
    resources: "المصادر",
  },
  exportCountryDataButton: "تصدير بيانات البلد",
  downloadScorecard: "تحميل بطاقة النتائج",
  overallDigitalHealthPhase: "المرحلة العامة للصحة الرقمية",
  overallDigitalHealthPhaseDescription:
    "النتيجة الإجمالية هي متوسط درجات مؤشرات GDHM",
  benchmark: {
    text: "المؤشر",
    textWithData: "المؤشر: {data}",
    benchmarkValues: {
      globalAverage: "المعدل العالمي",
      atAvg: "في المتوسط",
      belowAvg: "متوسط أدناه",
      aboveAvg: "فوق المتوسط",
    },
    benchmarkDescription:
      "قارن درجاتك الإجمالية مع المتوسط العالمي أو دول المرحلة الأخرى",
    benchmarkNoCountryForSelectedPhase: "لا توجد دول في المرحلة المحددة للقياس",
    serverErrorDescription:
      "غير قادر على تحميل البيانات المرجعية. يرجى المحاولة بعد مرور بعض الوقت",
    average: "متوسط",
  },
  indicator: "تفاصيل",
  score: "أحرز هدفا",
  govtData: "وافقت الحكومة",
  nonGovtData: "في انتظار موافقة الحكومة",
  selectYear: "حدد السنة",
  selectYearDescription:
    "لعرض البيانات الخاصة بسنة معينة ، يرجى تحديد السنة المطلوبة",
  phaseOverview: "نظرة عامة على المرحلة",
  countryProgressOverTime: "تقدم الدولة بمرور الوقت",
  countryProgressLineChart: {
    indicatorGroupingDescription: "حدد مؤشرا",
    globalAverage: "المعدل العالمي",
  },
  compareTo: "قارن ب",
  region: "منطقة",
};
